module.exports = __webpack_public_path__ + "media/images/icons/flags/RU-efec4687ce65c222bd1eaae02b64a028.svg";